import { useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'
import { ContactCoreFieldsFragment } from 'features/Contacts/graphql/ContactCoreFields.generated'
import { rvSelectedContactToTransfer } from 'features/Contacts/rv-deprecated/contacts'

import { GetDebitCardTransactions_getDebitCardTransactionsV2_transactions_payerDetails_debitCardAccount as PayerDebitCardAccount } from 'types/gql-types/GetDebitCardTransactions'
import { TransferContactFields } from 'pages/Transfer/ContactTransfer'
import { useTransferState } from 'pages/Transfer/Transfer.context'

import { useTransferQuery } from '../useTransferQuery/useTransferQuery'

type Contact = NonNullable<ContactCoreFieldsFragment>
type PaymentInstrument = NonNullable<Contact['paymentInstruments']>[0]

export const useContactTransferValues = () => {
  const transferValues = useTransferState()
    .transferValues as TransferContactFields

  const { accountById } = useTransferQuery()
  const selectedContact = useReactiveVar(rvSelectedContactToTransfer) as Contact

  const fromAccount = useMemo(
    () => accountById(transferValues.from) as PayerDebitCardAccount,

    [accountById, transferValues.from]
  )

  const toAccount = useMemo(
    () =>
      (selectedContact?.paymentInstruments || []).find(
        (account: PaymentInstrument) => account.id === transferValues.to
      ) as PaymentInstrument,
    [selectedContact?.paymentInstruments, transferValues.to]
  )

  return {
    fromAccount,
    toAccount,
    formValues: transferValues,
    selectedContact,
  }
}
